export class UpdateAlertRequest {
    constructor(name, priority, details, status) { }
}
